import React, { useState } from 'react';
import { IconButton } from 'material-ui';
import ActionHistory from 'material-ui/svg-icons/action/history';
import ServiceProvidersHistoryDialog from './ServiceProvidersHistoryDialog';
import ServiceProvidersList from './ServiceProvidersList';
import PropTypes from 'prop-types';

const ServiceProvidersView = ({ 
    serviceProviders, 
    updateServiceProviders, 
}) => {
    const [openHistoryDialog, setOpenHistoryDialog] = useState(false);

    const toggleHistoryDialog = React.useCallback(() => {
        setOpenHistoryDialog(prev => !prev);
    }, []);

    const handleChangeServiceProviders = React.useCallback((newServiceProviders) => {
        updateServiceProviders(newServiceProviders);
    }, []);

    return (
        <React.Fragment>
            <div style={{ margin: 0, display: 'flex', flexDirection: 'row-reverse' }} className='main__title row'>
                <div className='col-xs-1'>
                    <IconButton onClick={toggleHistoryDialog}>
                        <ActionHistory color='#B3B3B3' />
                    </IconButton>
                </div>
            </div>

            <div className='service-providers'>
                <ServiceProvidersList
                    serviceProviders={serviceProviders} 
                    handleChangeServiceProviders={handleChangeServiceProviders}
                />
            </div>
            
            <ServiceProvidersHistoryDialog
                open={openHistoryDialog}
                toggle={toggleHistoryDialog}
            />
        </React.Fragment>
    );
};

ServiceProvidersView.propTypes = {
    serviceProviders: PropTypes.array.isRequired,
    updateServiceProviders: PropTypes.func.isRequired,
};

export default ServiceProvidersView;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/ServiceProviders/ServiceProvidersView/ServiceProvidersView.jsx